import axios from "axios";

const APTOS_API_URL = 'https://fullnode.mainnet.aptoslabs.com/v1';

function isValidAptosAddress(address) {
  return axios
    .get(`${APTOS_API_URL}/accounts/${address}`)
    .then((data) => {
      return data.status === 200;
    })
    .catch((error) => {
      return false;
    });
}

export default {
  isValidAddress(address) {
    return isValidAptosAddress(address)
  },
};
